export const CHRONOMETER_TICK = 'CHRONOMETER_TICK';

export const chronometerTick = () => ({ type: CHRONOMETER_TICK }) as const;

export type ChronometerTickActions = ReturnType<typeof chronometerTick>;
